<script>
    export default {
        methods: {
            formatDate(date, onlyYear = false) {
                if(!date) return
                if (date === '-') return '-';

                const newDate = new Date(date);

                let
                    month = '' + (newDate.getMonth() + 1),
                    day = '' + newDate.getDate(),
                    year = newDate.getFullYear(),
                    hours = newDate.getHours(),
                    minute = '' + newDate.getMinutes();


                if (month.length < 2) month = '0' + month;
                if (day.length < 2) day = '0' + day;
                if (minute.length < 2) minute = '0' + minute;

                if (onlyYear) {
                    return day + '.' + month + '.' + year;
                } else {
                    return day + '.' + month + '.' + year + ' ' + hours + ':' + minute;
                }


            }
        }
    }
</script>